/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryPalAuthWithMissingInputRequest
 */
export interface RetryPalAuthWithMissingInputRequest {
    /**
     * 
     */
    categories: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the RetryPalAuthWithMissingInputRequest interface.
 */
export function instanceOfRetryPalAuthWithMissingInputRequest(value: object): value is RetryPalAuthWithMissingInputRequest {
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function RetryPalAuthWithMissingInputRequestFromJSON(json: any): RetryPalAuthWithMissingInputRequest {
    return RetryPalAuthWithMissingInputRequestFromJSONTyped(json, false);
}

export function RetryPalAuthWithMissingInputRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryPalAuthWithMissingInputRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'categories': json['categories'],
    };
}

export function RetryPalAuthWithMissingInputRequestToJSON(json: any): RetryPalAuthWithMissingInputRequest {
    return RetryPalAuthWithMissingInputRequestToJSONTyped(json, false);
}

export function RetryPalAuthWithMissingInputRequestToJSONTyped(value?: RetryPalAuthWithMissingInputRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categories': value['categories'],
    };
}

